import Tooltip from './Tooltip.jsx';

export default Tooltip;
